import styled from "styled-components";
import { Card, CardActionArea, CardContent, CardMedia, CardMediaProps } from "@material-ui/core";
import { CardProps } from "@material-ui/core/Card/Card";

export const MaterialCard = styled(Card)<CardProps & { width?: number }>`
    max-width: ${({ width = 100 }) => (width ? `${width}px` : `${width}%`)};
    margin: auto;
`;

export const MaterialCardMedia = styled(CardMedia)<CardMediaProps>`
    background-size: contain;
    background-position: center;
    width: 70%;
    margin: auto;
    height: 100%;
`;

export const CardPlaceholder = styled(CardMedia)<CardMediaProps & { width: number }>`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

export const MaterialActionArea = styled(CardActionArea)`
    height: 130px;
`;

export const MaterialCardContent = styled(CardContent)`
    height: 130px;
    padding: 0 ${({ theme }) => theme.spacing(1)}px;
    display: flex;
    align-items: center;
`;
